import { useTranslation } from "@emisgroup/acp-application-intl";
import { TableDataRowProps, TableHeaderProps, TableProps } from "../../../Common/UI/Index";

function ColumnDefinition(): TableHeaderProps[] {

  const { t: translate } = useTranslation();

  // Define the columns for the table
  const columns: TableHeaderProps[] = [
    {
      title: translate("Versioning.Heading.Name"),
      propertyName: "extractVersion",
      width: "160.4"
    },
    {
      title: translate("Versioning.Heading.Description"),
      propertyName: "description",
      width: "70"
    },
    {
      title: translate("Versioning.Heading.CreatedOn"),
      propertyName: "createdOn",
      width: "70"
    },
    {
      title: translate("Versioning.Heading.CreatedBy"),
      propertyName: "createdBy",
      width: "70"
    },
    {
      title: translate("Versioning.Heading.ModifiedOn"),
      propertyName: "modifiedOn",
      width: "70"
    },
    {
      title: translate("Versioning.Heading.ModifiedBy"),
      propertyName: "modifiedBy",
      width: "70"
    },
    {
      title: translate("Versioning.Heading.Status"),
      propertyName: "status",
      sortable: false,
      width: "70"
    }
  ];
  return columns;
}

/**
 * To populate the table data
 * @param versionList customized response data
 * @returns the formatted data to bind the table
 */
export const PopulateCustomTable = (versionList: TableDataRowProps[]): TableProps => {
  const table = {
    headerRow: ColumnDefinition(),
    dataRow: versionList
  };

  return table;
};
